import React from "react";
import styled from "styled-components";
import { DetailedCourse } from "@domain/lms/course/course";
import { Chapter } from "@domain/lms/course/courseContent";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { gap } from "@ui/styles/utils";
import { CourseExercises } from "@ui/pages/lms/coursePage/exercise/courseExercises";
import { SectionView } from "@ui/pages/lms/coursePage/section/sectionView";

interface ChapterViewProps extends React.HTMLAttributes<HTMLDivElement> {
	course: DetailedCourse;
	chapter: Chapter;
	chapterIndex: number;
}
export const ChapterView: React.FC<ChapterViewProps> = ({ course, chapter, chapterIndex, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<ChapterTitle>
				<span>{chapterIndex + 1}. </span>
				{chapter.title}
			</ChapterTitle>
			{chapter.sections.map((section) => (
				<SectionView key={section.id} section={section} course={course} />
			))}
			{chapter.exercises.size > 0 && <CourseExercises course={course} chapter={chapter} />}
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	padding: 36px 50px 50px;
	@media (max-width: 900px) {
		padding: 20px 16px 20px;
	}
	${gap(25)};
`;

const ChapterTitle = styled.div`
	${({ theme }) => theme.textStyles.title};
	> span {
		${({ theme }) => theme.textStyles.title};
		color: ${({ theme }) => theme.colors.secondary};
	}
`;
